// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Image = require("next/image").default;

let make = Image;

exports.make = make;
/* make Not a pure module */
